import { IGoodServiceTicketData } from 'meta/pages/goodsandservices'
import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IUserTicketData } from 'meta/pages/v4/ticket'
import { ITypeTicketData } from 'meta/pages/v4/typeticket'

export const getTap2GoDataFromV4Entities = (
  event: IEventData,
  location: ILocationData,
  ticket: IUserTicketData,
  typeTicket: ITypeTicketData
): IGoodServiceTicketData => {
  const gsTicketData: IGoodServiceTicketData = {
    customColor: typeTicket.custom?.color,
    dateEntry_tz: ticket.events[0]?.entryDateTime?.date_tz,
    event: {
      datetime_tz: event?.dateEvent.date_tz,
      id: event?.id,
      codeUrl: event?.codeUrl,
      name: event?.name,
      policy: {
        code: event?.policy.code.toLowerCase(),
      },
      location: {
        address: location.address,
        latitude: location.latitude,
        longitude: location.longitude,
      },
    },
    emissionDate_tz: ticket?.fiscalData?.emission?.dateTime?.date_tz,
    hasVaultEnabled: ticket?.vault?.enabled,
    locationName: location?.name,
    openDateEvent_tz: event?.dateOpen.date_tz,
    notes: typeTicket.notes,
    price: typeTicket.price,
    presale: typeTicket.presale,
    secret: ticket.secret,
    status: ticket.status.key.toLowerCase(),
    statusLabel: ticket.status.label,
    receiptsUri: ticket.fiscalData.receiptUri ?? '',
    validFrom: ticket.vault?.validFrom?.date,
    validFrom_tz: ticket.vault?.validFrom?.date_tz,
    validTo: ticket.vault?.validTo?.date,
    validTo_tz: ticket.vault?.validTo?.date_tz,
    totalPrice: typeTicket.total,
    webDetails: typeTicket.webDetails,
  }

  return gsTicketData
}
